// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__IVLot","description":"PatientConsentPreview_description__1V-GW"};